var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dashboard',{staticClass:"w-100 h-100"},[_c('Map')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }